import { render, staticRenderFns } from "./IrrigatorPaymentsReportedList.vue?vue&type=template&id=0faa740d&"
import script from "./IrrigatorPaymentsReportedList.vue?vue&type=script&lang=js&"
export * from "./IrrigatorPaymentsReportedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VAvatar,VImg,VSimpleTable})
